import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
  query publications {
    allPublicationsCsv(sort: {order: ASC, fields: id}) {
      edges {
        node {
          id
          place_id
					collection
          bib
          linc
        }
      }
    }
  }
`
const usePublicationsData = () => {
  let {
    allPublicationsCsv: { edges }
  } = useStaticQuery(query)

  let data = edges.map(x => x.node)

  return data
}

export default usePublicationsData;
